import type { Control } from 'react-hook-form';
import type { z } from 'zod';

import type { IdHeaderTagDto, IntegrationType } from '@/services/ws-header-tag/src/main/resources/rest-api';

import type { createSchema } from './schema';

export type FormValues = z.infer<ReturnType<typeof createSchema>>;

export interface TagFormRouteParams {
  integrationType: IntegrationType;
  headerTagId?: IdHeaderTagDto;
}

export interface FormFieldsProps {
  isSubmitting: boolean;
  control: Control<FormValues>;
  headerTagId?: IdHeaderTagDto;
  bidderIndex?: number;
}

export enum TagFormSearchKey {
  TAG_DETAILS_TAB = 'tagDetailsTab',
}
